import tw from 'tailwind-styled-components'

export const CampaignAppointmentManagerContainer = tw.div`
    py-10
    relative
`
